'use strict';

const { queryAll, addClass, hasClass } = require('../domUtil');
const enterAnimationView = require('../enterAnimationView');

const SELECTOR_ARM = '.pd-animate-up';
const CLASS_ANIMATED = 'm-animated';

/** One IntersectionObserver for every armed PD element. */
let observer = null;

/**
 * Observe armed elements that have not played yet.
 * @param {ParentNode} [root=document]
 */
function initPdAnimateUp(root) {
    const elements = queryAll(SELECTOR_ARM, root || document) || [];

    if (!elements.length) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.IntersectionObserver) {
        elements.forEach(el => addClass(el, CLASS_ANIMATED));
        return;
    }

    if (!observer) {
        observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }
                addClass(entry.target, CLASS_ANIMATED);
                observer.unobserve(entry.target);
            });
        }, enterAnimationView);
    }

    elements.forEach(el => {
        if (!hasClass(el, CLASS_ANIMATED)) {
            observer.observe(el);
        }
    });
}

/**
 * Wire load + PLP refresh so newly injected grid items are observed.
 */
function init() {
    initPdAnimateUp(document);

    document.body.addEventListener('plp:grid:ordered', () => {
        requestAnimationFrame(() => initPdAnimateUp(document));
    });

    if (typeof $ !== 'undefined') {
        $('body').on('search:updateProducts search:showMore', () => {
            requestAnimationFrame(() => initPdAnimateUp(document));
        });
    }
}

module.exports = {
    init,
    initPdAnimateUp,
    CLASS_ANIMATED
};
